// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=Great+Vibes&display=swap');
  
  body {
    background: linear-gradient(135deg, #f8f4ec 0%, #e8dfd0 100%);
    background-attachment: fixed;
    font-family: 'Cormorant Garamond', serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 100vh;
    margin: 0;
    padding: 20px;
    color: #5a4a42;
    position: relative;
  }
  
  /* New romantic floral background elements */
  body::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Cg fill='%23b38b6d' fill-opacity='0.1'%3E%3Cpath d='M80 20c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6zm20 0c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6zM80 0c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zM100 8c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM60 8c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM40 20c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6zM20 40c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM0 80c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zM8 60c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zM8 100c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zM20 120c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zM40 140c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zM80 160c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zM60 152c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zM100 152c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zM120 140c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zM140 120c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zM160 80c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM152 60c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM152 100c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zM140 40c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zM120 20c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z'/%3E%3Cpath d='M40 60c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM40 100c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM60 120c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM100 120c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM120 100c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM120 60c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM100 40c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zM60 40c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z'/%3E%3Cpath d='M80 60c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zM120 60c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zM120 100c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zM80 100c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20z' fill-opacity='0.05'/%3E%3C/g%3E%3C/svg%3E");
    z-index: -1;
  }
  
  /* Additional delicate floral pattern overlay */
  body::after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='280' height='280' viewBox='0 0 280 280'%3E%3Cg fill='%23d4c3ab' fill-opacity='0.08'%3E%3Cpath d='M140 140c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM140 196c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM84 140c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM84 196c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM196 140c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM196 196c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM28 84c17.7 0 32-14.3 32-32S45.7 20 28 20-4 34.3-4 52s14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24S41.2 76 28 76 4 65.2 4 52s10.8-24 24-24zM28 140c17.7 0 32-14.3 32-32S45.7 76 28 76-4 90.3-4 108s14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24S41.2 132 28 132 4 121.2 4 108s10.8-24 24-24zM28 196c17.7 0 32-14.3 32-32S45.7 132 28 132-4 146.3-4 164s14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24S41.2 188 28 188 4 177.2 4 164s10.8-24 24-24zM28 252c17.7 0 32-14.3 32-32S45.7 188 28 188-4 202.3-4 220s14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24S41.2 244 28 244 4 233.2 4 220s10.8-24 24-24zM84 252c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM140 252c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM196 252c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM252 84c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM252 140c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM252 196c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM252 252c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-56c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24z'/%3E%3C/g%3E%3C/svg%3E");
    z-index: -1;
    opacity: 0.6;
  }
  
  /* Base styles for components */
  h1 {
    text-align: center;
    color: #947060;
    font-family: 'Cormorant Garamond', serif;
    font-size: 2.8rem;
    letter-spacing: 5px;
    margin: 40px 0;
    position: relative;
    padding: 25px 0;
    font-weight: 400;
    text-transform: uppercase;
  }
  
  h1::before, h1::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    background: linear-gradient(to right, transparent, #d4b59e, transparent);
    width: 280px;
  }
  
  h1::before {
    top: 0;
  }
  
  h1::after {
    bottom: 0;
  }
  
  button {
    width: 100%;
    padding: 14px;
    background: linear-gradient(to right, #b38b6d, #d4b59e);
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(179, 139, 109, 0.3);
    font-family: 'Cormorant Garamond', serif;
    letter-spacing: 1px;
  }
  
  button:hover {
    background: linear-gradient(to right, #a07a5f, #c4a58e);
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(179, 139, 109, 0.4);
  }
  
  input[type="text"] {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #e0d5c5;
    border-radius: 4px;
    font-size: 16px;
    background-color: rgba(255, 255, 255, 0.8);
    color: #5a4a42;
    font-family: 'Cormorant Garamond', serif;
    transition: all 0.3s ease;
    box-sizing: border-box;
    max-width: 100%;
  }
  
  input[type="text"]:focus {
    outline: none;
    border-color: #b38b6d;
    box-shadow: 0 0 0 3px rgba(179, 139, 109, 0.2);
    background-color: white;
  }
  
  input[type="text"]::placeholder {
    color: #c0b0a0;
  }
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #5a4a42;
    font-size: 1.05rem;
  }
  
  /* Responsive styles */
  @media (max-width: 600px) {
    h1 {
      font-size: 2.2rem;
    }
    
    h1 span {
      font-size: 2rem;
    }
  }
  
  /* Root element styles for React */
  #root {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export default GlobalStyles;